import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Inbox } from '../../icons'
import Text from '../Text'

const EmptyState = ({
  customIcon,
  header,
  text,
  cta,
  className
}) => (
  <div className={classnames('empty-state', className)}>
    <div className='empty-state__icon'>
      {customIcon || <Inbox />}
    </div>
    {header && (
      <Text bold className='empty-state__header'>{header}</Text>
    )}
    <Text
      size={header ? 'small' : 'standard'}
      className='empty-state__text'
    >
      {text}
    </Text>
    {cta && (
      <div className='empty-state__cta'>
        {cta}
      </div>
    )}
  </div>
)

EmptyState.propTypes = {
  /**
  * Pass icon if you need something else than empty inbox
  */
  customIcon: PropTypes.node,
  /**
  * Sometimes we show emphasized bold header
  */
  header: PropTypes.string,
  /**
  *  Greyed out text always there
  * */
  text: PropTypes.string.isRequired,
  /**
  *  Pass button if needed
  * */
  cta: PropTypes.node,
  className: PropTypes.string
}

export default EmptyState
